import clsx from 'clsx';

import { SOURCE_FILTER_TREE_NODE_ID } from 'constants/filter';
import { TransformedFilterTreeNode } from 'components/tree/FilterTree';
import FilterSearchPanel, { FilterSearchPanelProps } from 'components/panel/filter/FilterSearchPanel';

//
// --- Types ---

export interface SourceFilterSearchPanelProps extends FilterSearchPanelProps {
  companyName: string;
}

//
// --- Helper Function ---

/** updates tooltip on Branded Registration node if company provided */
function addCompanyNameToBrandedRegistrationNode(
  treeData: ReadonlyArray<TransformedFilterTreeNode>,
  companyName: string
): ReadonlyArray<TransformedFilterTreeNode> {
  const brandedRegistrationTooltip = `Supplier companies that have completed ${
    companyName
      ? `${companyName}'s registration and/or have participated in ${companyName} events, contracts, or portals.`
      : 'registration and/or have participated in events, contracts, or portals with your company.'
  }`;

  return treeData.map((treeNode: TransformedFilterTreeNode) =>
    Array.isArray(treeNode.children)
      ? {
          ...treeNode,
          children: treeNode.children.map((childNode: TransformedFilterTreeNode) =>
            childNode.id === SOURCE_FILTER_TREE_NODE_ID.REGISTERED_SUPPLIER
              ? { ...childNode, tooltip: brandedRegistrationTooltip }
              : childNode
          )
        }
      : treeNode
  );
}

//
// --- SourceFilterSearchPanel Component ---

const SourceFilterSearchPanel: React.FC<SourceFilterSearchPanelProps> = props => {
  const {
    className,
    companyName,
    'data-testid': dataTestId = 'source-filter-search-panel',
    filterTreeData,
    ...remainingFilterSearchPanelProps
  } = props;

  return (
    <FilterSearchPanel
      className={clsx('source-filter-search-panel', className)}
      data-testid={dataTestId}
      filterTreeData={addCompanyNameToBrandedRegistrationNode(filterTreeData, companyName)}
      {...remainingFilterSearchPanelProps}
    />
  );
};

export default SourceFilterSearchPanel;
